import http from '@/plugins/axios';
export default {
  atual: function atual() {
    return http.apiCore.get('/v1/termos_uso/atual');
  },
  aceitar: function aceitar(payload) {
    return http.apiCore.post('/v1/termos_uso/aceitar', payload);
  }
};